import { RoleContext } from '@BUP/contexts/RoleContext'
import { ASSISTANT, ECE, STUDENT } from '@BUP/constants'
import ErrorMessage from '@BUP/components/Error/Message'
import { createContext, useContext, useEffect } from 'react'
import { useGetCurrentCourses } from '@BUP/hooks/Courses/useGetCurrentCourses'
import { setTrackedUserData } from '@BUP/services/tracker'
import { setMonitoredContext } from '@BUP/services/monitor'
import BupLoading from '@BUP/components/Loading/Main'

export const CourseContext = createContext()

// TODO: manage error
export const CourseContextProvider = ({ children, role: roleProp }) => {
  const contextRole = useContext(RoleContext)
  const roleType = roleProp?.type ?? contextRole?.type
  const { courses, isLoading } = useGetCurrentCourses()
  const canRenderWithoutCourses = roleType === ECE || roleType === ASSISTANT

  // Si el rol es COUNSELOR o ASSISTANT, courses será []
  // Evitar lógica de loader y null para estos casos
  useEffect(() => {
    if (courses && courses.length > 0) {
      setTrackedUserData({ courses: courses.map(registration => registration.course.name) })
      setMonitoredContext('courses', Object.fromEntries(courses.map(({ course }) => ([course.id, course.name]))))
      // return () => removeUserData('courses')
    }
  }, [courses])

  if (isLoading) return <BupLoading />

  if (!courses) return null

  if (Array.isArray(courses) && courses.length === 0 && canRenderWithoutCourses) {
    return <CourseContext.Provider value={courses}>{children}</CourseContext.Provider>
  }

  // Integrar texto a translations
  if (Array.isArray(courses) && courses.length === 0 && roleType === STUDENT) {
    return (
      <ErrorMessage
        message='Estudiante no tiene curso asignado. Contacta con tu institución para más información.'
        withSignOut
      />
    )
  }

  return (
    <CourseContext.Provider value={courses}>{children}</CourseContext.Provider>
  )
}
